import { Card } from "@heroui/react";
import { YandexLoginButton } from "@/features/auth";

export const LoginPage = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[70vh] py-12">
      <div className="w-full max-w-sm flex flex-col gap-6">
        {/* Логотип Kizi */}
        <div className="flex items-center justify-center gap-3 select-none">
          <div className="flex items-center justify-center w-10 h-10 rounded-xl bg-gradient-to-tr from-indigo-600 to-cyan-500 text-white shadow-md">
            <svg
              className="w-6 h-6"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="m8 3 4 8 5-5 5 15H2L8 3z" />
            </svg>
          </div>
          <div className="flex flex-col">
            <span className="text-xl font-bold tracking-tight leading-tight">
              Kizi
            </span>
            <span className="text-[11px] font-medium uppercase tracking-wider text-neutral-400">
              Workspace
            </span>
          </div>
        </div>

        {/* Карточка авторизации */}
        <Card className="p-6 flex flex-col items-center text-center backdrop-blur-md">
          <h1 className="text-lg font-semibold tracking-tight">Вход в систему</h1>
          <p className="mt-1 text-xs text-neutral-400 max-w-xs">
            Авторизуйтесь через Яндекс ID для доступа к рекламным кампаниям и модулям автоматизации
          </p>

          {/* Кнопка входа через Яндекс */}
          <div className="mt-6 flex justify-center w-full">
            <YandexLoginButton size="lg" />
          </div>

          <div className="mt-6 text-[11px] text-neutral-400 leading-relaxed">
            Безопасный вход с сохранением сессии в защищённых HttpOnly куках
          </div>
        </Card>
      </div>
    </div>
  );
};
